import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IKullaniciDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IKullaniciDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetUserByUsername: any[];
  GetUserByUsername_dummy: any[];
  isComp927048Visible: "visible" | "hidden";
  isComp390385Visible: "visible" | "hidden";
}

export class KullaniciDetay_ScreenBase extends React.PureComponent<
  IKullaniciDetay_ScreenProps,
  any
> {
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "6bbeedf8-4bbe-4005-a731-633746fabdf6",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 720642, PropertyName: "value", Value: "Kullanıcı" },
        { Id: 927048, PropertyName: "value", Value: "Yazılım Mühendisi" },
        {
          Id: 289681,
          PropertyName: "value",
          Value: "Erzene mah. 7777/1 sk. No:17 Bornova/İzmir",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetUserByUsername: [],
      isComp927048Visible: "hidden",
      isComp390385Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("kullanicidetay", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.KullaniciDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("kullanicidetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("kullanicidetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.KullaniciDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      kullanicidetay_62817_value:
        this.state.GetUserByUsername?.at?.(0)?.profilePhotoUrl ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  KullaniciDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Username_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UserName ?? this.props.screenInputs.username,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KullaniciDetay/KullaniciDetayPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserByUsername = result?.data.getUserByUsername;
    formVars.kullanicidetay_62817_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].profilePhotoUrl
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].profilePhotoUrl
        : null
    );
    formVars.kullanicidetay_274950_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].fullName
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].fullName
        : null
    );
    formVars.kullanicidetay_118154_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].username
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].username
        : null
    );
    formVars.kullanicidetay_943537_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].phoneNumber
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].phoneNumber
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KullaniciDetayPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KullaniciDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.kullanicidetay_62817_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].profilePhotoUrl
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].profilePhotoUrl
        : null
    );

    formVars.kullanicidetay_274950_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].fullName
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].fullName
        : null
    );

    formVars.kullanicidetay_118154_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].username
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].username
        : null
    );

    formVars.kullanicidetay_943537_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetUserByUsername !== undefined
        ? stateVars.GetUserByUsername?.length > 0
          ? stateVars.GetUserByUsername[0].phoneNumber
          : null
        : this.state.GetUserByUsername?.length > 0
        ? this.state.GetUserByUsername[0].phoneNumber
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  KullaniciDetayComponent_621074_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KullaniciDetayComponent_468633_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.KullaniciDetayPageInit();
    }
  }
}
